// EvidenceKeeper — canonical pricing + proprietary product names (single source of truth).
// Feature names MUST appear consistently across the app exactly as written here.
export const PRODUCT = {
  smartIntake: "Smart Evidence Intake",
  factFilter: "Fact Filter",
  justice: "Justice",
  vault: "Evidence Vault",
  reportReady: "Report Ready",
  spr: "Secure Professional Review",
};

// Four pricing options shown on the subscription/pricing screens.
export const TIERS = [
  {
    key: "free",
    name: "Basic Watch",
    price: 0,
    priceLabel: "Free",
    trial: false,
    tagline: "Start documenting at no cost",
    features: [
      "20 KeeperCredits per month",
      "10 Evidence Vault uploads",
      "Manual timeline & calendar entries",
      "Limited Fact Filter",
      "Basic PDF export",
    ],
  },
  {
    key: "standard",
    name: "Standard Protection",
    price: 24.99,
    priceLabel: "$24.99",
    trial: true,
    tagline: "Everything you need to build a clear record",
    features: [
      "150 KeeperCredits per month",
      "Unlimited Evidence Vault uploads",
      "Smart Evidence Intake",
      "Advanced Fact Filter",
      "Bulk uploads & zip file support",
      "Standard professional (Report Ready) reports",
    ],
  },
  {
    key: "pro",
    name: "Litigator Pro",
    price: 44.99,
    priceLabel: "$44.99",
    trial: true,
    featured: true,
    tagline: "The full litigation-ready toolkit",
    features: [
      "1,000 KeeperCredits per month",
      "Justice advanced pattern analysis",
      "Order Consistency Check",
      "Pattern Analytics",
      "Parent-Child Communication analytics",
      "Master Exhibit Index",
      "Bates-ready exports",
      "Final Master Case Report",
      "Secure Professional Review links",
    ],
  },
];

// One-time purchase (per-case), not a subscription.
export const CASE_PREP = {
  key: "case_prep",
  name: "Case Prep Pass",
  price: 89,
  priceLabel: "$89",
  oneTime: true,
  tagline: "One-time · full Litigator Pro access for a single case",
  features: [
    "Full Litigator Pro feature access for one case",
    "No ongoing subscription",
    "Unlimited final (court-ready) exports for that case",
  ],
};

// Additional KeeperCredits top-up pack.
export const CREDIT_PACK = { key: "credits_100", credits: 100, price: 9.99, priceLabel: "$9.99" };

export const PLAN_DISPLAY_NAME = {
  free: "Basic Watch",
  none: "Basic Watch",
  standard: "Standard Protection",
  pro: "Litigator Pro",
};

// Trial helper — "then $X.XX/month starting <date>"
export function trialCopy(price, trialEndIso) {
  let dateStr = "";
  try {
    if (trialEndIso) dateStr = new Date(trialEndIso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
  } catch { /* ignore */ }
  const base = `7-day free trial, then $${price.toFixed(2)}/month`;
  return dateStr ? `${base}. Billing starts ${dateStr}. Cancel anytime before then and your card will not be charged.` : `${base}. Cancel anytime during the trial and your card will not be charged.`;
}
